import { render, staticRenderFns } from "./detailsCredits.vue?vue&type=template&id=50b456f6&scoped=true&"
import script from "./detailsCredits.vue?vue&type=script&lang=js&"
export * from "./detailsCredits.vue?vue&type=script&lang=js&"
import style0 from "./detailsCredits.vue?vue&type=style&index=0&id=50b456f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b456f6",
  null
  
)

export default component.exports